import t from "../../i18n/i18n";
import React from "react";
import { useSelector } from "react-redux";

function PageProfile() {
  const {
    user: { avatar },
  } = useSelector((store) => store.auth);

  return (
    <div className="profile-main-panel">
      <div className="profile-main-box">
        <div className="profile-panel-header">
          <i className="user-icon">
            <img src="../images/user-icon-white.png" alt="" />
          </i>
          <h3>{t("MainProfile.Profile")}</h3>
        </div>
        <div className="profile-inside-warp">
          <div className="profile-warp-top">
            <div className="user-profile-thumb">
              <span className="thumb">
                <img src={avatar || "/images/user-thumn-m.png"} alt="" />
              </span>
            </div>
            <div className="profile-game-nav-large">
              <a href="/loyal-member" target="_parent">
                <span className="nav-icon-title">
                  <span className="nav-ico">
                    <img src="../images/game-icon-white2.png" alt="" />
                  </span>
                  <span className="icon-nav-title">{t("MainProfile.Play")}</span>
                </span>
              </a>
            </div>
          </div>
          <div className="profile-warp-bot-nav">
            <ul>
              <li>
                <a href="/recharge-center" target="_parent">
                  <span className="nav-icon-title">
                    <span className="nav-ico">
                      <img src="../images/doller-ico-white.png" alt="" />
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a href="https://ddt.21kgames.com/wallpapers/" target="_parent">
                  <span className="nav-icon-title">
                    <span className="nav-ico">
                      <img src="../images/crown-large-white.png" alt="" />
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a href="/support" target="_parent">
                  <span className="nav-icon-title">
                    <span className="nav-ico">
                      <img src="../images/support-ico-white.png" alt="" />
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a href="https://ddt.21kgames.com/" target="_parent">
                  <span className="nav-icon-title">
                    <span className="nav-ico">
                      <img src="../images/config-icon-white.png" alt="" />
                    </span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageProfile;
